/**
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 *
 * Based on: https://github.com/Automattic/_s/blob/master/js/navigation.js
 */

const VISIBLE_CSS_CLASS = 'is-visible';
const FOCUSED_CSS_CLASS = 'is-focused';
const ZERO_INDEX = 0;

class Navigation {
  /**
   * @param containerSelector
   * @param buttonSelector
   */
  constructor(containerSelector = '.js-top-bar', buttonSelector = '.js-main-nav-trigger') {
    let links;
    let container = document.querySelector(containerSelector);
    let button = document.querySelector(buttonSelector);
    let menu = container.getElementsByTagName('ul')[ZERO_INDEX];

    if (!container) {
      return;
    }

    if ('undefined' === typeof button) {
      return;
    }

    // Hide menu toggle button if menu is empty and return early.
    if ('undefined' === typeof menu) {
      button.style.display = 'none';
      return;
    }

    menu.setAttribute('aria-expanded', 'false');
    if (!menu.classList.contains('js-main-nav')) {
      menu.classList.add('js-main-nav');
    }

    button.onclick = () => {
      if (container.classList.contains(VISIBLE_CSS_CLASS)) {
        container.classList.remove(VISIBLE_CSS_CLASS);
        button.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-expanded', 'false');
      } else {
        container.classList.add(VISIBLE_CSS_CLASS);
        button.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-expanded', 'true');
      }
    };

    // Get all the link elements within the menu.
    links = menu.getElementsByTagName('a');
    this.registerEvents(links, container);
  }

  registerEvents(links, container) {
    if ('ontouchstart' in window) {
      this.touchSupportRegister(container);
    } else {
      // Each time a menu link is focused or blurred, toggle focus.
      // used for keyboard [TAB] navigation
      [].slice.call(links).forEach(link => {
        link.addEventListener('focus', () => this.toggleFocus(link), true);
        link.addEventListener('blur', () => this.toggleFocus(link), true);
      });
    }
  }

  /**
   * Toggles .is-focused class on an element.
   */
  toggleFocus(link) {
    // Move up through the ancestors of the current link until we hit .js-main-nav.
    while (!link.classList.contains('js-main-nav')) {

      // On li elements toggle the class .focus.
      if ('li' === link.tagName.toLowerCase()) {
        if (link.classList.contains(FOCUSED_CSS_CLASS)) {
          link.classList.remove(FOCUSED_CSS_CLASS);
        } else {
          link.classList.add(FOCUSED_CSS_CLASS);
        }
      }

      link = link.parentElement;
    }
  }

  /**
   * Register touch related listeners on menu links
   *
   * @param container
   */
  touchSupportRegister(container) {
    let parentLink = container.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');
    [].slice.call(parentLink).forEach(item => {
      item.addEventListener('touchstart', event => this.touchStartHandler(event), false);
    })
  }

  /**
   * Handle touch events on a given menu link and toggles .is-focused class
   *
   * @param event
   */
  touchStartHandler(event) {
    const menuItem = event.target.parentNode;

    if (!menuItem.classList.contains(FOCUSED_CSS_CLASS)) {
      event.preventDefault();
      [].slice.call(menuItem.parentNode.children).forEach(child => {
        child.classList.remove(FOCUSED_CSS_CLASS);
      });
      menuItem.classList.add(FOCUSED_CSS_CLASS);
    } else {
      menuItem.classList.remove(FOCUSED_CSS_CLASS);
    }
  }

}

export default Navigation;
